import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
  } from "@/components/ui/dialog"

export const OutCallsModal = ({ isMobile }: { isMobile: boolean }) => {
    return (
        <Dialog>
            <DialogTrigger className={`border-none underline hover:cursor-pointer text-left text-gray-500 ${isMobile ? "text-xs" : "text-base"}`}>Conditions liées aux appels sortants</DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Conditions liées aux appels sortants</DialogTitle>
                    <DialogDescription>
                        Appels sortants inclus limité à 100 correspondants différents maximum par mois par utilisateur et 1h maximum par appel (hors coût du services de n° spéciaux, destinations internationales non incluses et renvoi d’appel vers numéros externes). Au delà, facturation hors forfait au tarif de 0,15€/min HT
                    </DialogDescription>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    )
}